<template>
  <v-container class="pt-0">
    <div
      class="d-flex justify-end mb-3 modal-processor-test"
      style="height: 90px; align-items: end;"
    >
      <BaseButton
        color="primary"
        @click="executeTestProcessor()"
      >
        Testar processador
      </BaseButton>
    </div>
    <BaseCard
      :has-main-container="true"
      style="border: none;"
    >
      <v-expansion-panels
        v-model="panel"
        :accordion="true"
      >
        <v-expansion-panel class="mb-4 grayf8">
          <v-expansion-panel-header class="font-weight-bold color--text-black-054">
            Configurar - Teste do processador
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <SchemaConfiguration
              key="test-input"
              :radio-options="inputRadioOptions"
              :byte-radio-options="inputByteRadioOptions"
              :list-schemas="listSchemas"
              :object-value="codemirrorLocalStorage"
              codemirror-title="Payload (Deve ser um JSON)"
              schema-title="Inputs"
              option-model="schema"
              context="input"
              @hasChangedValues="hasChangedInputValues"
            />
            <v-divider />
            <h4 class="color--text-black-054 py-4">
              SharedData
            </h4>
            <v-row dense>
              <v-col sm="4">
                <BaseInput
                  ref="keySharedData"
                  v-model="sharedDataObject.key"
                  label="Chave"
                />
              </v-col>

              <v-col sm="4">
                <BaseInput
                  ref="valueSharedData"
                  v-model="sharedDataObject.value"
                  label="Valor"
                />
              </v-col>
              <v-col
                sm="1"
                class="text-right app-align-items-center"
              >
                <BaseButton
                  type="text"
                  class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                  :is-disabled="!sharedDataObject.key || !sharedDataObject.value"
                  @click="addSharedData(sharedDataObject)"
                >
                  {{ isEditingSharedData ? 'Atualizar' : 'Adicionar' }}
                </BaseButton>
                <BaseButton
                  v-if="isEditingSharedData"
                  type="text"
                  class="app-button__link-text app-button--hide-ripple app-button--no-hover px-2"
                  @click="cancelEditSharedData"
                >
                  Cancelar
                </BaseButton>
              </v-col>
            </v-row>
            <v-row
              dense
              class="mb-4"
            >
              <v-col
                cols="auto"
                sm="10"
                class="pl-0"
              >
                <template>
                  <BaseDataTable
                    v-if="visibleSharedData.length"
                    :headers="['', '']"
                    :items="visibleSharedData"
                    :hide-headers="true"
                    :hide-actions="true"
                    :disable-pagination="true"
                    background-color="transparent"
                  >
                    <template v-slot:inject-items="{ items }">
                      <tr
                        :key="items.item.key"
                      >
                        <td>
                          {{ items.item.key }}
                        </td>
                        <td>
                          {{ items.item.value }}
                        </td>
                        <td
                          class="text-right app-align-items-center"
                          style="justify-content: flex-end; min-width: 130px;"
                        >
                          <BaseButton
                            type="text"
                            class="app-button__link-text app-button--hide-ripple app-button--no-hover pa-0"
                            @click="editSharedData(items.index)"
                          >
                            Editar
                          </BaseButton>
                          <BaseButton
                            type="text"
                            class="app-button__link-text app-button--hide-ripple app-button--no-hover pa-0"
                            @click="removeSharedData(items.index)"
                          >
                            Apagar
                          </BaseButton>
                        </td>
                      </tr>
                    </template>
                  </BaseDataTable>
                </template>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="mb-4 grayf8">
          <v-expansion-panel-header class="font-weight-bold color--text-black-054">
            Resultado - Teste do processador
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-alert
              v-if="testResult.success !== null"
              dense
              text
              :type="testResult.success ? 'success' : 'error'"
              class="mb-6"
            >
              {{ testResult.success ? 'Sucesso' : 'Erro' }}
            </v-alert>
            <v-tabs
              v-model="tabIndex"
              class="tabs tab-details"
            >
              <v-tabs-slider />
              <v-tab
                v-for="tab, index in ['Resultado', 'Shared Data', 'Saída']"
                :key="index"
                class="tab"
              >
                <span class="tab--text">{{ tab }}</span>
              </v-tab>
            </v-tabs>
            <v-tabs-items
              v-model="tabIndex"
              :style="{ 'background': isDarkTheme ? '#2d2d2d' : '#f8f8f8'}"
            >
              <v-tab-item
                :transition="false"
                class="mt-4"
              >
                <template v-if="testResult.capturedLogs">
                  <div class="app-align-items-center">
                    <v-spacer />
                    <BaseButton
                      :has-icon="true"
                      class="ma-0 ml-2 pa-4"
                      size="x-small"
                      @click="copyLog(testProcessorLog)"
                    >
                      <v-icon>{{ isLogCopied ? 'mdi-check-all' : 'mdi-content-copy' }}</v-icon>
                    </BaseButton>
                  </div>
                  <BaseCodemirror
                    ref="log-codemirror"
                    v-model="testProcessorLog"
                    cm-ref="log-codemirror"
                    :read-only="true"
                    class="my-4"
                  />
                </template>
                <div v-else>
                  <p class="color--text-black-054 font-weight-bold d-flex justify-center pa-4">
                    Nenhum resultado para ser exibido.
                  </p>
                </div>
              </v-tab-item>
              <v-tab-item
                :transition="false"
                class="mt-4"
              >
                <BaseDataTable
                  v-if="testResult.sharedData && testResult.sharedData.length"
                  :headers="['', '']"
                  :items="testResult.sharedData"
                  :hide-headers="true"
                  :hide-actions="true"
                  background-color="transparent"
                  :disable-pagination="true"
                  style="width: 100%;"
                >
                  <template v-slot:inject-items="{ items }">
                    <tr
                      :key="items.item.key"
                    >
                      <td>
                        {{ items.item.key }}
                      </td>
                      <td
                        style="max-width: 450px; padding: 10px 0px!important;"
                      >
                        {{ items.item.value }}
                      </td>
                    </tr>
                  </template>
                </BaseDataTable>
                <div v-else>
                  <p class="color--text-black-054 font-weight-bold d-flex justify-center pa-4">
                    Nenhum shared data para ser exibido.
                  </p>
                </div>
              </v-tab-item>
              <v-tab-item
                :transition="false"
                class="mt-4"
              >
                <SchemaConfiguration
                  v-if="testResult.output || testResult.outputTransformed"
                  key="test-output"
                  :radio-options="outputRadioOptions"
                  :list-schemas="listSchemas"
                  :object-value="{ payload: testResult.outputTransformed || testResult.output, isBase64, ...transformLocalStorage }"
                  option-model="bytes"
                  context="output"
                  @handleClick="hasChangedOutputValues"
                  @hasChangedValues="hasChangeOptionValue"
                  @showDiffModal="$emit('showDiffModal', { old: testObject.payload, newTransformed: testResult.outputTransformed, newOriginal: testResult.output})"
                  @encodeDecodeBase64="encodeDecodeBase64"
                />
                <div v-else>
                  <p class="color--text-black-054 font-weight-bold d-flex justify-center pa-4">
                    Nenhum output para ser exibido.
                  </p>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <BaseSnackbar
        :active-snackbar="feedback"
        :type-snackbar="feedbackColor"
        :text-snackbar="feedbackMessage"
        @closeSnackbar="feedback = !feedback"
      />
    </BaseCard>
  </v-container>
</template>
<script>
import BaseCodemirror from '../../BaseCodemirror'
import { mapActions } from 'vuex'
import BaseDataTable from '../../BaseDataTable'
import BaseSnackbarConfiguration from '../../../mixins/BaseSnackbarConfiguration'
import BaseSnackbar from '../../BaseSnackbar'
import loader from '../../../global/loader'
import SchemaConfiguration from './SchemaConfiguration'
import UtilsLocalStorage from '../../../mixins/UtilsLocalStorage'
import UtilsCodemirror from '../../../mixins/UtilsCodemirror'

export default {
  components: { BaseCodemirror, BaseDataTable, BaseSnackbar, SchemaConfiguration },
  mixins: [ BaseSnackbarConfiguration, UtilsLocalStorage, UtilsCodemirror ],
  props: {
    openTestProcessor: {
      type: Boolean,
      required: true
    },
    uuidProcessor: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: () => ({
    tabIndex: null,
    panel: [0, 1],
    listSchemas: [],
    itemId: '',
    itemFocus: false,
    sharedDataList: [],
    isEditingSharedData: false,
    sharedDataIndex: null,
    testObject: {
      schema: '',
      payload: '',
      options: '',
      shared_data: {}
    },
    sharedDataObject: {
      key: '',
      value: ''
    },
    showProtobufSchema: false,
    testResult: {},
    testProcessorLog: '',
    testingProcessor: false,
    isLogCopied: false,
    configOption: 'schema',
    byteOption: null,
    fromPID: null,
    inputRadioOptions: [
      { text: 'Schema', value: 'schema' },
      { text: 'Bytes', value: 'bytes' },
      { text: 'Copiar de um processador', value: 'fromPID' },
    ],
    inputByteRadioOptions: [
      { text: 'Base64', value: 'base64' },
      { text: 'Texto', value: 'text' }
    ],
    outputRadioOptions: [
      { text: 'Schema', value: 'schema' },
      { text: 'Bytes', value: 'bytes' },
    ],
    codemirrorLocalStorage: null,
    transformLocalStorage: null,
    isBase64: false
  }),
  computed: {
    visibleSharedData(){
      return this.sharedDataList.filter((sd, index) => {
        return sd.value !== '' && index !== this.sharedDataIndex
      })
    }
  },
  watch: {
    panel(value) {
      if(value === 0){
        this.codemirrorLocalStorage = this.getInputsTestLocalStorage()
      }
      if(value === 1){
        this.transformLocalStorage = this.getInputsTransformLocalStorage()
      }
    }
  },
  created() {
    this.getSchema()
    this.getAndAddInputsLocalStorage()
  },
  methods: {
    ...mapActions(['apiGetSchemaMessages', 'apiTestProcessor', 'apiTransformSchemaMessage']),
    async getSchema() {
      this.listSchemas = await this.apiGetSchemaMessages()
    },
    editSharedData(index) {
      const sharedData = this.sharedDataList[index]

      this.sharedDataObject = {
        key: sharedData.key,
        value: sharedData.value
      }

      this.isEditingSharedData = true
      this.sharedDataIndex = index
    },
    cancelEditSharedData() {
      this.sharedDataObject = {
        key: "",
        value: ""
      }
      this.isEditingSharedData = false
      this.sharedDataIndex = null
    },
    addSharedData(sharedData) {
      const newSharedData = {
        key: sharedData.key,
        value: sharedData.value
      }

      if (this.isEditingSharedData) {
        this.sharedDataList.splice(this.sharedDataIndex, 1, newSharedData)
        this.isEditingSharedData = false
        this.sharedDataIndex = null
      } else {
        this.sharedDataList.push(newSharedData)
      }

      this.sharedDataObject = {
        key: "",
        value: ""
      }
    },
    removeSharedData(index) {
      this.sharedDataIndex = index

      this.sharedDataList.splice(this.sharedDataIndex, 1)
      this.sharedDataIndex = null
    },
    isValidJson(json) {
      if(json) {
        try {
          JSON.parse(this.stringifyValue(json))
          return true
        } catch(e) {
          this.showFeedback({
            color: 'error',
            message: 'JSON inválido.'
          })
          return false
        }
      }
      return true
    },
    async executeTestProcessor(){
      let payloadObject = null
      let uuidProcessor = this.uuidProcessor
      let payload = this.testObject.payload
      let payloadLS = { payload }
      const shared_data = Object.fromEntries(this.sharedDataList.map(({ key, value }) => [key, value]))

      this.testObjectAPI = { uuidProcessor, shared_data }

      if(this.configOption === 'schema'){
        if(this.isValidJson(payload)) {
          payloadObject = payload && typeof payload === 'string' ? JSON.parse(payload) : payload
        } else {
          return
        }
        const input = {
          schema: this.testObject.schema || '',
          payload: payloadObject || {},
          options: {
            "import_schemas": this.testObject.options || ''
          }
        }
        this.testObjectAPI.input = input
        payloadLS = this.testObjectAPI.input

      } else if(this.configOption === 'fromPID') {
        this.testObjectAPI.fromPID = this.fromPID
      } else if(this.configOption === 'bytes') {
        this.testObjectAPI.input = {
          payload: this.byteOption === 'base64' ?  payload : this.encodeByte(payload)
        }
      }

      localStorage.setItem("idt-inputs-test-processor", this.stringifyValue({
        ...payloadLS,
        shared_data,
        fromPID: this.fromPID || '',
        configOption: this.configOption,
        byteOption: this.byteOption }
      ))

      try {
        let result = await this.apiTestProcessor(this.testObjectAPI)

        this.testResult = {
          capturedLogs: result.captured_logs || null,
          success: result.success,
          output: result.output || null,
          outputTransformed: result.output ? this.decodeByte(result.output) : null,
          sharedData: Object.entries(result.shared_data).map(([key, value]) => ({ key, value}))
        }
        this.panel = 1
        this.isBase64 = false

        if(this.testResult.capturedLogs){
          setTimeout(() => {
            this.setCodemirrorValue('log-codemirror', this.testResult.capturedLogs)
          }, 200);
        }

        this.showFeedback({
          color: "success",
          message: `Teste efetuado. Verifique os detalhes navegando nas abas.`,
        })
      } catch (e) {
        loader.stopProgressLoadPage()
        this.showFeedback({
          color: "error",
          message: `Erro ao testar o processador!`,
        })
      }
    },
    getAndAddInputsLocalStorage() {
      if(this.openTestProcessor){
        this.sharedDataList = []
        let objectLocalStorage = this.getInputsTestLocalStorage()
        this.transformLocalStorage = this.getInputsTransformLocalStorage()

        if(objectLocalStorage){
          let { schema, payload, options, shared_data, fromPID } = objectLocalStorage
          this.testObject = {
            schema: schema,
            payload: payload,
            options: options ? options.import_schemas : ''
          }
          this.fromPID = fromPID;
          Object.keys(shared_data).forEach(key => {
            this.sharedDataList.push({key, value: shared_data[key]});
          })

          if(!this.transformLocalStorage){
            this.transformLocalStorage = { schema, options }
          }
        }
      }
    },
    async copyLog(log){
      await navigator.clipboard.writeText(log)
      this.isLogCopied = true
      setTimeout(() => {
        this.isLogCopied = false
      }, 900);
    },
    hasChangedInputValues(value){
      let { configOption, byteOption, fromPIDModel, configObject } = value
      this.configOption = configOption
      this.byteOption =  byteOption || null
      Object.assign(this.testObject, { ...configObject })
      this.fromPID = fromPIDModel
    },
    hasChangeOptionValue(){
      this.transformLocalStorage = this.getInputsTransformLocalStorage()
    },
    async hasChangedOutputValues({ configObject }){
      let { schema , options } = configObject
      let payload = {
        "schema": schema,
        "input": this.testResult.output
      }
      if(options){
        payload.options = {
          "import_schemas": options
        }
      }

      localStorage.setItem("idt-inputs-transform-processor", this.stringifyValue({...payload}))

      try {
        let result = await this.apiTransformSchemaMessage(payload)
        this.$set(this.testResult, 'outputTransformed', result)
      } catch (error) {
        this.$set(this.testResult, 'outputTransformed', null)
        let errorMsg = {
          "400": "Não foi possível transformar a saída.",
          "404": "Schema/Message não encontrado(s)."
        }
        this.showFeedback({
          color: "error",
          message: errorMsg[error.response.status] || 'Erro ao transformar saída.'
        })
      }
    },
    encodeDecodeBase64(){
      if(this.isBase64) {
        this.$set(this.testResult, 'outputTransformed', this.decodeByte(this.testResult.output))
      } else {
        this.$set(this.testResult, 'outputTransformed', this.testResult.output)
      }
      this.isBase64 = !this.isBase64
    }
  }
}

</script>
